"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ensureArray = function (value) {
    return Array.isArray(value) ? value : [value];
};
exports.default = ensureArray;
